import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Select from "react-select";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";

const API_BASE = "https://inspecciongnvback-dev.azurewebsites.net/api/v1/";
const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

const CreaOrden = () => {
  const { id } = useParams();
  const cookie = new Cookies();

  const [sistemasCombustible, setSistemasCombustible] = useState([]);
  const [sistemaSeleccionado, setSistemaSeleccionado] = useState("");
  const [tiposSistema, setTiposSistema] = useState([]);
  const [tipoSistemaSeleccionado, setTipoSistemaSeleccionado] = useState("");
  const [tipoGas, setTipoGas] = useState("");

  const [tipoOrden, setTipoOrden] = useState(null);
  const [listaChequeo, setListaChequeo] = useState(null);
  const [opcionesTipoOrden, setOpcionesTipoOrden] = useState([]);
  const [opcionesListaChequeo, setOpcionesListaChequeo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const obtenerFechaColombia = () => {
    const ahoraUTC = new Date();
    const opciones = {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formateador = new Intl.DateTimeFormat("es-CO", opciones);
    const [dia, mes, año] = formateador.format(ahoraUTC).split("/");
    return `${año}-${mes}-${dia}`;
  };

  const fechaCreacion = obtenerFechaColombia();

  const fetchGet = async (url, setState) => {
    try {
      const res = await fetch(url);
      const data = await res.json();
      setState(data);
    } catch (err) {
      console.error("Error al obtener datos:", err);
    }
  };

  const fetchGetAuth = async (url, setState, mapToSelect = false) => {
    try {
      const res = await axios.get(url, { auth: AUTH });
      const data = mapToSelect
        ? res.data.map((item) => ({ value: item.id, label: item.nombre }))
        : res.data;
      setState(data);
    } catch (err) {
      console.error("Error al obtener datos con auth:", err);
    }
  };

  useEffect(() => {
    fetchGet(`${API_BASE}ObtenerSistemaCombustible`, setSistemasCombustible);
    fetchGetAuth(`${API_BASE}ObtenerTipoOrdenes`, setOpcionesTipoOrden, true);
    fetchGetAuth(
      `${API_BASE}ObtenerListasVigentes`,
      setOpcionesListaChequeo,
      true,
    );
  }, []);

  useEffect(() => {
    if (sistemaSeleccionado) {
      fetchGet(
        `${API_BASE}ObtenerTipoSistemaCombustible/${sistemaSeleccionado}`,
        setTiposSistema,
      );
    }
  }, [sistemaSeleccionado]);

  const crearOrden = async (e) => {
    e.preventDefault();

    if (isLoading) return;

    if (
      !tipoOrden ||
      !listaChequeo ||
      !tipoGas ||
      !sistemaSeleccionado ||
      !tipoSistemaSeleccionado
    ) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor complete todos los campos antes de continuar.",
      });
      return;
    }

    setIsLoading(true);

    Swal.fire({
      title: "Creando orden...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        `${API_BASE}CreaOrdenes`,
        {
          fechaCreacion,
          tallerId: cookie.get("tallerId"),
          direccion: "",
          tipoOrdenServicioId: tipoOrden?.value,
          vehiculoId: id,
          equipoId: "0",
          listaChequeoId: listaChequeo?.value,
          UsuarioId: cookie.get("id"),
          chipVehiculo: "",
          chipTaller: "",
          estado: "En Revisión",
          sistemaCombustibleId: sistemaSeleccionado,
          tipoSistemaCombustibleId: tipoSistemaSeleccionado,
          tipoGas,
          fechaConversion: null,
          fechaPrestacionServicio: null,
        },
        { auth: AUTH },
      );

      const data = response.data;

      // ✅ Si el API retorna un ID (orden creada)
      if (data && !isNaN(data)) {
        Swal.fire({
          icon: "success",
          title: "¡Orden creada!",
          text: `La orden fue creada con el número: ${data}`,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          window.location.href = "/admin/Ordenes/";
        });
      }
      // ❌ Si retorna mensaje de error
      else {
        Swal.fire({
          icon: "error",
          title: "Orden no creada",
          text:
            data ||
            "No se pudo crear la orden. Por favor revise la información ingresada.",
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error al crear la orden",
        text:
          error.response?.data ||
          "Ocurrió un error al intentar crear la orden.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Generar Orden de Servicio</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form onSubmit={crearOrden}>
                  <Row className="pl-lg-4">
                    <Col lg="6">
                      <FormGroup>
                        <label>Tipo Orden de Servicio</label>
                        <Select
                          options={opcionesTipoOrden}
                          onChange={setTipoOrden}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label>Lista de Chequeo</label>
                        <Select
                          options={opcionesListaChequeo}
                          onChange={setListaChequeo}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="pl-lg-4">
                    <Col lg="6">
                      <FormGroup>
                        <label>Tipo Gas</label>
                        <Input
                          type="select"
                          onChange={(e) => setTipoGas(e.target.value)}
                        >
                          <option value="">Seleccione</option>
                          <option value="GNV">GNV</option>
                          <option value="GLP">GLP</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="pl-lg-4">
                    <Col lg="6">
                      <FormGroup>
                        <label>Sistema Combustible</label>
                        <Input
                          type="select"
                          onChange={(e) =>
                            setSistemaSeleccionado(e.target.value)
                          }
                        >
                          <option value="">Seleccione</option>
                          {sistemasCombustible.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label>Tipo Conversión</label>
                        <Input
                          type="select"
                          onChange={(e) =>
                            setTipoSistemaSeleccionado(e.target.value)
                          }
                        >
                          <option value="">Seleccione</option>
                          {tiposSistema.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button
                    type="submit"
                    color="primary"
                    size="lg"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <Spinner size="sm" className="mr-2" />
                        Creando...
                      </>
                    ) : (
                      "Finalizar"
                    )}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreaOrden;
